import * as React from "react";
function SvgDots3H(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle cx={3} cy={16} r={3} />
      <circle cx={16} cy={16} r={3} />
      <circle cx={29} cy={16} r={3} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDots3H);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
